"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportsSdk = void 0;
var _acsReportsSdk = _interopRequireWildcard(require("@adsk/acs-reports-sdk"));
var sdk = _acsReportsSdk;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ALLOY_TO_REPORT_ENV = {
  [_acsScWebPlatformApi.ENVS.QA]: _acsReportsSdk.ApiEnv.QA,
  [_acsScWebPlatformApi.ENVS.STAGING]: _acsReportsSdk.ApiEnv.STG,
  [_acsScWebPlatformApi.ENVS.PRODUCTION]: _acsReportsSdk.ApiEnv.PROD
};
const ALLOY_TO_REPORT_REGION = {
  [_acsScWebPlatformApi.REGIONS.US]: _acsReportsSdk.Region.US,
  [_acsScWebPlatformApi.REGIONS.EMEA]: _acsReportsSdk.Region.EMEA,
  [_acsScWebPlatformApi.REGIONS.APAC]: _acsReportsSdk.Region.APAC,
  [_acsScWebPlatformApi.REGIONS.AUS]: _acsReportsSdk.Region.AUS
};
let initialized = false;
const getReportsSdk = () => {
  if (!initialized) {
    sdk.setRequestConfig({
      env: ALLOY_TO_REPORT_ENV[(0, _acsScWebPlatformApi.getEnv)()],
      region: ALLOY_TO_REPORT_REGION[(0, _acsScWebPlatformApi.getRegion)()],
      getAccessToken: () => (0, _acsScWebPlatformApi.getCurrentToken)().then(_ref => {
        let {
          accessToken
        } = _ref;
        return accessToken;
      })
    });
    initialized = true;
  }
  return sdk;
};
exports.getReportsSdk = getReportsSdk;
//# sourceMappingURL=ReportsSdk.js.map